"use client"

import { Badge } from "@/components/ui/badge"

const products = [
  {
    id: 1,
    name: "Modern Sofa",
    category: "Furniture",
    revenue: "$12,450",
    aiFeatures: ["Room Visualizer", "2D to 3D"],
    image: "/modern-sofa.png",
  },
  {
    id: 2,
    name: "Pendant Light",
    category: "Lighting",
    revenue: "$8,320",
    aiFeatures: ["Magic Background", "Youzu Lens"],
    image: "/elegant-pendant-light.png",
  },
  {
    id: 3,
    name: "Coffee Table",
    category: "Furniture",
    revenue: "$7,890",
    aiFeatures: ["Room Visualizer", "2D to 3D"],
    image: "/modern-living-room-coffee-table.png",
  },
  {
    id: 4,
    name: "Ceramic Vase",
    category: "Decor",
    revenue: "$5,670",
    aiFeatures: ["Magic Background", "Youzu Lens"],
    image: "/ceramic-vase.png",
  },
  {
    id: 5,
    name: "Bookshelf",
    category: "Furniture",
    revenue: "$4,980",
    aiFeatures: ["Room Visualizer", "2D to 3D"],
    image: "/3d-bookshelf.png",
  },
]

export function AnalyticsTopProducts() {
  return (
    <div className="space-y-4">
      {products.map((product) => (
        <div key={product.id} className="flex items-center gap-3">
          <div className="relative h-16 w-16 overflow-hidden rounded-md">
            <img
              src={product.image || "/placeholder.svg"}
              alt={product.name}
              className="object-cover"
              width={64}
              height={64}
            />
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between">
              <h4 className="text-sm font-medium">{product.name}</h4>
              <span className="text-sm font-medium text-green-600">{product.revenue}</span>
            </div>
            <div className="flex flex-wrap items-center gap-1 mt-1">
              <Badge variant="outline" className="text-xs">
                {product.category}
              </Badge>
              {product.aiFeatures.map((feature) => (
                <Badge key={feature} variant="secondary" className="text-xs">
                  {feature}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
